import { motion } from "framer-motion";
import ScrollReveal from "./scroll-reveal";

const features = [
  {
    id: 1,
    icon: "fas fa-award",
    title: "Premium Quality",
    description: "Crafted with the finest materials and attention to detail for lasting durability.",
  },
  {
    id: 2,
    icon: "fas fa-users",
    title: "Ergonomic Design",
    description: "Scientifically designed for comfort and productivity in modern workspaces.",
  },
  {
    id: 3,
    icon: "fas fa-leaf",
    title: "Sustainable Materials",
    description: "Eco-friendly manufacturing processes and sustainable material sourcing.",
  },
  {
    id: 4,
    icon: "fas fa-tools",
    title: "Custom Solutions",
    description: "Tailored furniture solutions to match your unique workspace requirements.",
  },
  {
    id: 5,
    icon: "fas fa-shipping-fast",
    title: "Fast Delivery",
    description: "Quick and secure delivery across India with professional installation.",
  },
  {
    id: 6,
    icon: "fas fa-headset",
    title: "24/7 Support",
    description: "Dedicated customer support team ready to assist with all your needs.",
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 bg-gradient-to-r from-primary/5 to-accent/5 dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-4">
              Why Choose KASA Furniture
            </h2>
            <p className="text-xl text-neutral max-w-2xl mx-auto">
              Experience the difference with our premium office furniture solutions
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <ScrollReveal key={feature.id} delay={index * 0.1}>
              <motion.div
                className="text-center p-6 rounded-2xl glass-effect backdrop-blur-sm hover-lift hover-cursor group"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <motion.div
                  className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300"
                  whileHover={{ rotate: 360 }}
                  transition={{ duration: 0.6 }}
                >
                  <i className={`${feature.icon} text-white text-2xl`}></i>
                </motion.div>
                <h3 className="text-xl font-semibold mb-3 text-primary dark:text-white">
                  {feature.title}
                </h3>
                <p className="text-neutral dark:text-gray-300">
                  {feature.description}
                </p>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}